const toBoolean = (value: string = '') =>
  ['true', 'false', '0', '1'].includes(value.toLowerCase()) ? ['true', '1'].includes(value.toLowerCase()) : undefined;

export default toBoolean;
